import { useEffect, useRef } from "react";

import styles from "./popover.module.css";

type PopoverProps = {
  isOpen: boolean;
  onClose: () => void;
  anchor: React.ReactNode;
  children: React.ReactNode;
};

export const Popover = ({
  isOpen,
  onClose,
  anchor,
  children,
}: PopoverProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  return (
    <div className={styles.wrapper} ref={ref}>
      <div className={styles.anchor}>{anchor}</div>

      {isOpen && (
        <div className={styles.overlay} onClick={onClose}>
          <div className={styles.box} onClick={(e) => e.stopPropagation()}>
            {children}
          </div>
        </div>
      )}
    </div>
  );
};
